import { useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import { RxReload } from "react-icons/rx";
import DataStatusTable from "./DataStatusTable";
import VersionLockUnlock from "./VersionLockUnlock";
import AccessTo from "../../../components/is-show/AccessTo";
import { CM } from "../../router/AddRoutesJson";

function IndexOfClientProgressTab() {
  const [reRender, setRedender] = useState("");
  const [isSpinning, setIsSpinning] = useState(false); // Control spin animation

  const queryClient = useQueryClient();
  const handleReset = () => {
    setRedender(Math.random());
    setIsSpinning(true);
    // queryClient.resetQueries({
    //   queryKey: ["clientProgressDataWithStatus_clientProgressDataWithStatus"],
    //   exact: true,
    // });
    // queryClient.resetQueries({
    //   queryKey: ["clientList_Status"],
    //   exact: true,
    // });
    setTimeout(() => setIsSpinning(false), 500);
  };

  return (
    <>
      <div className=" flex justify-between items-center">
        <AccessTo role={[CM]}>
          <VersionLockUnlock />
        </AccessTo>
        <button
          className={`border border-[1.5px] px-2 mx-2 py-2 mb-2 bg-gray-100 rounded-sm border-blue-700 ${
            isSpinning ? "ts animate-bounce" : ""
          }`}
          onClick={handleReset}
          // disabled={isSpinning}
        >
          <RxReload
            size={15}
            className={isSpinning ? "animate-spin-fast " : ""}
          />
        </button>
      </div>

      {/* <div className="flex justify-end px-2 mb-3">
        <button
          className="border border-[1.5px] px-2 py-2 bg-gray-100 rounded-sm border-blue-700"
          onClick={() => setRedender(Math.random())}
        >
          <RxReload size={17} />
        </button>
      </div> */}
      {/* key={reRender} */}
      <DataStatusTable key={reRender} />
    </>
  );
}

export default IndexOfClientProgressTab;
